<template>
    <div class="w-full">
        <div class="rounded-lg grow min-h-[850px] bg-white">
            <div class="px-20 pt-10">
                <h2 class="text-gray-700 text-2xl underline">Veuillez validé le document</h2>
            </div>
            <div class="mx-auto w-[89%] rounded-lg px-7 py-8 mt-10">
                <div class="w-full flex justify-center mt-14 mb-20">
                    <img src="../../../../assets/uigb-logo.png" alt="logo uigb" class="h-20 w-auto object-cover">
                </div>
                    <p class="text-gray-700 mb-4 text-2xl text-right">Abidjan, le xxxxxxxxxxxx</p>
                    <p class="text-gray-700 mb-4 text-2xl">Reference…………………….</p>

                    <div class="flex justify-end mt-24 mb-24">
                        <p class="text-gray-700 mb-4 text-2xl mr-10 font-bold">
                            A<br>
                            Monsieur le Directeur Général<br>
                            BANK NAME
                        </p>
                    </div>

                    <h2 class="text-gray-700 mb-16 text-2xl"><span class="font-bold">Objet</span>: Notification de fin de contrat</h2>

                    <div class="mb-4">
                        <p class="text-gray-700 mb-6 text-2xl">
                            Madame/Monsieur le Directeur General,
                        </p>
                        <p class="text-gray-700 mb-6 text-2xl">
                            Par la présente, nous vous informons que <span class="font-bold">{{ nom ?? "TITLE NAME" }}</span>, précédemment <span class="font-bold">{{ poste ?? "POSITION" }}</span> au sein de notre Université, titulaire du numéro de compte <span class="font-bold">{{ nbcp ?? "ACCOUNT NUMBER" }}</span> domicilié dans vos livres, ne fait plus partie de notre personnel dépuis le <span class="font-bold">{{ startDate ?? "DATE" }}</span> suite à <span class="font-bold">{{ motivation ?? "MOTIVE" }}</span>.
                        </p>
                        <p class="text-gray-700 mb-6 text-2xl">
                            Le solde de tout compte vous a été transféré.
                        </p>
                        <p class="text-gray-700 mb-20 text-2xl">
                            Par conséquent, nous vous adressons ce courrier pour servir et valoir ce que de droit.
                        </p>
                    </div>

                    <div class="text-right text-2xl">
                        <p class="text-gray-700 mr-32 font-bold">SIGNATURE</p>
                    </div>

                    <div class="flex justify-end">
                        <div class="w-[300px] h-[150px] rounded-xl border border-dashed mt-5 flex flex-col items-center justify-center p-3">
                            <p v-if="!signature" class="font-extralight text-black">Pas de signature</p>
                            <img v-else :src="getPath" :alt="signature" class="h-full object-contain">
                        </div>
                    </div>
            </div>
            <div class="inline-flex gap-x-3 justify-center w-full mt-48">
                <button v-on:click="saveForm" class="h-14 w-32 bg-[#5357ec] text-white rounded-lg text-xl font-semibold hover:bg-[#4349d1] transition-all duration-300">
                    <Loader2 v-if="asSend" class="animate-spin mx-auto text-white"/>
                    <span v-if="!asSend">Valider</span>
                </button>
                <button class="h-14 w-32 bg-[#f44336] text-white rounded-lg text-xl font-semibold hover:bg-[#d32f2f] transition-all duration-300">
                    Refuser
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import {Loader2} from "lucide-vue-next";
import API from "@/service/API";
import toast from "@/components/ui/toast";
export default {
    name: "NotifFinContratValid",
    components: {Loader2},
    data() {
        return {
            id: "",
            asSend: false,
            nom: null,
            poste: null,
            startDate: null,
            nbcp: null,
            motivation: null,
            signature: null
        };
    },
    created(){
        this.id = this.$route.params.id;
    },
    mounted() {
        this.getOneUserDocDemande();
        this.signature = localStorage.getItem("signature") ?? undefined;
    },
    computed:{
        getPath(){
            return `https://backend-ehr.iugb-ci.com/public/image/${this.signature}`;
        }
    },
    methods: {
        getOneUserDocDemande(){
            API.get("/user-docs/"+this.id)
            .then((data)=>{
                if(data.data["status"] == 'success'){
                    this.nom= JSON.parse(data.data["data"]["content"]).nom;
                    this.poste= JSON.parse(data.data["data"]["content"]).poste
                    this.startDate= JSON.parse(data.data["data"]["content"]).startDate
                    this.nbcp= JSON.parse(data.data["data"]["content"]).nbcp
                    this.motivation= JSON.parse(data.data["data"]["content"]).motivation
                }
            })
            .catch(e=>{console.log(e)})
        },
        saveForm(){
            this.asSend = true;
            if(!this.signature){
                toast.error("Erreur","Veuillez enregistré votre signature à partie de votre profile",5000);
                return;
            }
            const data = {
                "validation_rh" : 1,
                "validator_id" : localStorage.getItem("userId"),
                "validator_sign" : this.signature
            }
            API.put("user-docs/"+this.id, data)
                .then((response) => {
                    if(response.data["status"] == 'success'){
                        toast.success("Succès","Demande enregistré avec succès",4000);
                    }else{
                        toast.error("Oops..",response.data["message"],4000)
                    }
                })
                .catch(() => {
                    toast.error("Oops..","Il semble avoir une erreur, merci de réessayé.",4000)
                }).finally(()=>{
                    this.asSend = false;
                });
        }
    },
}
</script>